import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { createCodeModel } from '../common-code/CommonCode';
import { OperatorInfo } from '../operator-info/OperatorInfo';

/**
 * # DynamicCode
 *
 * DynamicCode을 설명하세요.
 */
export const DynamicCode = types.model('DynamicCode').props({
  regDt: types.number,
  updDt: types.number,
  dynamicCd: createCodeModel(),
  cdId: types.number,
  cdNm: types.string,
  value: types.maybeNull(types.string),
  ordr: types.number,
  useYn: types.boolean,
  dscrpt: types.maybeNull(types.string),
  regUser: types.maybeNull(OperatorInfo),
  updUser: types.maybeNull(OperatorInfo),
});

// --------------------------------------------------------------------------
type TDynamicCode = Instance<typeof DynamicCode>;
type TDynamicCodeSnapshot = SnapshotOut<typeof DynamicCode>;

export interface IDynamicCode extends TDynamicCode {}
export type TDynamicCodeKeys = keyof TDynamicCodeSnapshot & string;
export interface IDynamicCodeSnapshot extends TDynamicCodeSnapshot {}
export const createDynamicCode = () => types.optional(DynamicCode, {} as TDynamicCode);
